<!-- Write Off  -->
<p-dialog
  [visible]="writeOffModal()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '991px': '100vw' }"
  [style]="{ width: '620px' }"
  styleClass="no-header-modal"
  (onHide)="closeDialogEvent()"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Modal Header -->
    <div
      class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300"
    >
      <h2 class="mb-0 text-sm">{{ 'WRITE_OFF.TITLE' | translate }}</h2>
      <i
        class="fa fa-times text-xl text-600 cursor-pointer"
        (click)="closeDialogEvent()"
      ></i>
    </div>

    <!-- Content -->
    <form [formGroup]="writeOffForm" (ngSubmit)="submitWriteOff()">
      <div class="p-4">
        <!-- Block -->
        <div class="mb-4">
          <h4 class="text-sm text-600 mb-3 font-bold">
            {{ 'WRITE_OFF.AMOUNT_LABEL' | translate }}
          </h4>

          <ul class="list-none p-0 m-0 text-sm">
            <li class="mt-3 flex align-items-center">
              <p-radioButton
                name="writeOffType"
                value="full"
                formControlName="writeOffType"
                inputId="writeOffAmountOption1"
              />
              <div class="ml-2" for="writeOffAmountOption1">
                {{ 'WRITE_OFF.TOTAL_BALANCE_DUE' | translate }}
                <span class="font-bold">
                  {{ totalBalanceDue | currencyformat }}</span
                >
              </div>
            </li>
            <li class="mt-3 flex align-items-center">
              <p-radioButton
                name="writeOffType"
                value="partial"
                formControlName="writeOffType"
                inputId="writeOffAmountOption2"
              />
              <div class="ml-2" for="writeOffAmountOption2">
                <span class="mr-2">{{ 'WRITE_OFF.AMOUNT' | translate }}</span>
                <p-inputNumber
                  formControlName="amount"
                  [min]="0"
                  [max]="totalBalanceDue"
                  [step]="1"
                  [showButtons]="false"
                  [locale]="'en-US'"
                />
                @if (
                  writeOffForm.get('amount')?.touched &&
                  writeOffForm.get('amount')?.invalid
                ) {
                  <app-error-msg
                    [errors]="writeOffForm.get('amount')?.errors"
                    [fieldLabel]="'WRITE_OFF.AMOUNT' | translate"
                  />
                }
              </div>
            </li>
          </ul>
        </div>

        <!-- Block -->
        <div>
          <h4 class="text-sm text-600 mb-3 font-bold">
            {{ 'WRITE_OFF.REASON_LABEL' | translate }}
          </h4>
          <textarea
            pInputTextarea
            formControlName="reason"
            class="w-full text-sm h-5rem"
            [ngClass]="{
              'ng-invalid ng-dirty':
                writeOffForm.get('reason')?.invalid &&
                writeOffForm.get('reason')?.touched,
            }"
          >
          </textarea>
          @if (
            writeOffForm.get('reason')?.touched &&
            writeOffForm.get('reason')?.invalid
          ) {
            <app-error-msg
              [errors]="writeOffForm.get('reason')?.errors"
              [fieldLabel]="'WRITE_OFF.REASON' | translate"
            />
          }
        </div>
      </div>

      <!-- Modal Footer -->
      <div
        class="p-3 border-top-1 border-300 flex align-items-center justify-content-between"
      >
        <p-button
          type="button"
          (click)="closeDialogEvent()"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          styleClass="p-button-link text-sm"
        />
        <p-button
          type="submit"
          [label]="'WRITE_OFF.SUBMIT' | translate"
          styleClass="text-sm p-button-danger"
          [loading]="btnLoading"
        />
      </div>
    </form>
  </ng-template>
</p-dialog>
<!-- Write Off -->

<!-- Write Off List -->
<p-dialog
  [visible]="showList()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '991px': '100vw' }"
  [style]="{ width: '800px' }"
  styleClass="no-header-modal"
  (onHide)="closeDialogEvent()"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Modal Header -->
    <div
      class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300"
    >
      <h2 class="mb-0 text-sm">{{ 'WRITE_OFF.LIST_TITLE' | translate }}</h2>
      <i
        class="fa fa-times text-xl text-600 cursor-pointer"
        (click)="closeDialogEvent()"
      ></i>
    </div>
    <!-- Modal Header -->

    <!-- Table -->
    <p-table
      [value]="writeOffTableData"
      styleClass="shadow-2 p-0"
      responsiveLayout="scroll"
    >
      <ng-template pTemplate="header">
        <tr class="text-xs font-bold">
          <th class="text-600 white-space-nowrap">
            {{ 'WRITE_OFF.TABLE.NUMBER' | translate }}
          </th>
          <th class="text-600 white-space-nowrap">
            {{ 'WRITE_OFF.TABLE.DATE' | translate }}
          </th>
          <th class="text-600 white-space-nowrap">
            {{ 'WRITE_OFF.TABLE.AMOUNT' | translate }}
          </th>
          <th class="text-600 white-space-nowrap">
            {{ 'WRITE_OFF.TABLE.STATUS' | translate }}
          </th>
          <th class="text-600 white-space-nowrap">
            {{ 'WRITE_OFF.TABLE.REASON' | translate }}
          </th>
          <th class="text-600 white-space-nowrap">
            {{ 'WRITE_OFF.TABLE.ACTIONS' | translate }}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-writeOff>
        @if (!loading) {
          <tr class="text-sm">
            <td class="py-2 border-bottom-1 border-300 white-space-nowrap">
              {{ writeOff.number_prefix }}
            </td>
            <td class="py-3 border-bottom-1 border-300 white-space-nowrap">
              {{ writeOff.created_date | datetimeformat: 'mediumDate' }}
            </td>
            <td class="py-3 border-bottom-1 border-300 white-space-nowrap">
              {{ writeOff.amount_in_minor_currency | currencyformat }}
            </td>
            <td class="py-3 border-bottom-1 border-300 white-space-nowrap">
              {{
                writeOff.is_voided
                  ? ('WRITE_OFF.TABLE.VOIDED' | translate)
                  : ('WRITE_OFF.TABLE.ACTIVE' | translate)
              }}
            </td>
            <td class="py-3 border-bottom-1 border-300">
              {{ writeOff.write_off_reason }}
            </td>
            <td class="py-3 border-bottom-1 border-300 white-space-nowrap">
              @if (!writeOff.is_voided) {
                <div class="">
                  <p-button
                    icon="fa fa-angle-down"
                    [label]="'common.BUTTONS.BTN_ACTIONS' | translate"
                    iconPos="right"
                    styleClass="surface-0 p-button-outlined border-300 text-600 text-sm"
                    (click)="member1.toggle($event)"
                  />
                  <p-popover
                    #member1
                    styleClass="overflow-hidden right-0 text-sm w-8rem"
                  >
                    <ng-template #content>
                      <ul class="list-none -m-4 px-0 py-2 text-xs text-600">
                        <li
                          class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                          (click)="voidWriteOff(writeOff)"
                        >
                          <i class="fa fa-ban text-base text-500 mr-2"></i
                          >{{ 'WRITE_OFF.VOID' | translate }}
                        </li>
                      </ul>
                    </ng-template>
                  </p-popover>
                </div>
              }
            </td>
          </tr>
        }
        <!-- Skeleton Loading -->
        @if (loading) {
          <tr class="text-sm">
            <td class="py-2 border-bottom-1 border-300">
              <p-skeleton width="70%" height="1.5rem" />
            </td>
            <td class="py-2 border-bottom-1 border-300">
              <p-skeleton width="80%" height="1.5rem" />
            </td>
            <td class="py-2 border-bottom-1 border-300">
              <p-skeleton width="60%" height="1.5rem" />
            </td>
            <td class="py-2 border-bottom-1 border-300">
              <p-skeleton width="90%" height="1.5rem" />
            </td>
            <td class="py-2 border-bottom-1 border-300">
              <p-skeleton width="100px" height="2rem" />
            </td>
          </tr>
        }
      </ng-template>
      <!-- Empty State -->
      <ng-template pTemplate="emptymessage" let-columns>
        @if (!loading) {
          <tr>
            <td colspan="5" class="text-center p-4">
              {{ 'WRITE_OFF.NO_RECORDS' | translate }}
            </td>
          </tr>
        }
      </ng-template>
    </p-table>
    <!-- Table -->
  </ng-template>
</p-dialog>
<!-- Write Off List -->

<!-- Void Invoice Modal -->
<p-dialog
  [visible]="showVoidModal"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '630px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Content -->
    <form [formGroup]="VoidWriteOffForm">
      <div class="relative text-center p-4">
        <div
          class="fa fa-times opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
          (click)="showVoidModal = false"
        ></div>
        <img
          width="160"
          class="block mx-auto"
          src="/assets/img/void-invoice-img.svg"
          alt="Image"
        />
        <h4 class="text-base md:text-lg my-3 font-bold">
          {{ 'WRITE_OFF.WRITE_OFF_DEL_CONFI' | translate }} <br />
          {{ selectedWriteOff.number_prefix }} ?
        </h4>
        <p class="text-600 md:w-26rem mx-auto mb-0">
          {{ 'WRITE_OFF.WRITE_OFF_DEL_INFO' | translate }}
        </p>
      </div>
      <!-- Content -->

      <!-- Content -->
      <div class="surface-100 p-4">
        <label class="font-medium text-700 text-xs mb-2 block uppercase">{{
          'WRITE_OFF.REASON' | translate
        }}</label>
        <textarea
          pInputTextarea
          formControlName="void_reason"
          class="text-sm w-full h-5rem"
        ></textarea>
        @if (VoidReasonFormControl.touched && VoidReasonFormControl.invalid) {
          <app-error-msg
            [errors]="VoidReasonFormControl.errors"
            [fieldLabel]="'WRITE_OFF.REASON' | translate"
          />
        }
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div
        class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-primary p-button-text text-sm"
          (click)="showVoidModal = false"
        ></button>

        <button
          pButton
          pRipple
          type="button"
          [label]="'WRITE_OFF.VOID' | translate"
          class="p-button-danger text-sm"
          [loading]="btnLoading"
          (click)="deleteWriteOff(VoidWriteOffForm)"
        ></button>
      </div>
      <!-- Modal Footer -->
    </form>
  </ng-template>
</p-dialog>
<!-- Void Invoice Modal -->
